module.exports = __webpack_public_path__ + "assets/img/logo.a3d18228.jpg";